import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import NamespaceList from "../../components/Namespace";
import NamespaceModal from "../../components/Namespace/Modal";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import * as NamespaceActions from "../../store/actions/Namespace";
import ErrorMsgs from "../../constants/Errors.json";
import * as UserActions from "../../store/actions/User";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { useLocation } from "react-router-dom";
import Permission from "../../components/Common/Permission";
import Button from "sushiweb/Button";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { getPath } from "../../utils";

const Namespace = (props) => {
  const location = useLocation();
  const searchQueryParams = location.search;
  const params = new URLSearchParams(searchQueryParams);
  const configMetadata = {
    namespace: params.get("namespace"),
    key: params.get("key"),
    entity: params.get("entity"),
    entityId: params.get("entityId"),
  };

  const [namespaces, setNamespaces] = useState([]);
  const [modalState, setModalState] = useState(false);

  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  const getList = () => {
    props
      .getNamespaces({ limit: 20 })
      .then((response) => {
        setNamespaces(getPath(response, "namespaces", []));
      })
      .catch((err) => {
        props.setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        });
      });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <ChangeLogView>
      <FlexContainer align="flex-start">
        <Heading>Namespaces</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[]}>
            <Button
              onClick={() => handleClick("Create")}
              className="sushi-btn ml-12"
              icon={<AddEdit />}
              btnColor="coal"
            >
              Create
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[]}>
        <NamespaceList
          namespaces={namespaces}
          setNamespaces={setNamespaces}
          configMetadata={configMetadata}
        />
      </Permission>
      {modalState && (
        <NamespaceModal
          modalState={modalState}
          handleClose={handleClose}
          setNamespaces={setNamespaces}
        />
      )}
    </ChangeLogView>
  );
};

const ChangeLogView = styled.section`
  height: calc(100vh - 200px);
  .MuiAutocomplete-root {
    margin-bottom: unset !important;
  }
`;

const mapDispatchToProps = (dispatch) => {
  return {
    getNamespaces: bindActionCreators(NamespaceActions.getNamespaces, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(Namespace);
